/* eslint-disable no-restricted-syntax */

import { MessageError } from "src/types/errors/errors";

import { eventsErrors } from "./specific-message-errors.ts/events-error";
import { crmadsErrors } from "./specific-message-errors.ts/crmads-error";
import { missionsError } from "./specific-message-errors.ts/missions-error";

export const messagesError: MessageError[] = [
  {
    key: 'Erro',
    value: 'Mensagem',
  },
  ...eventsErrors,
  ...crmadsErrors,
  ...missionsError
];

export function responseMessage(err: string | string[]): string {
  if (typeof err === 'string') {
    return translateErrorMessage(err);
  }

  const translatedMessages: string[] = err.map(translateErrorMessage);

  return translatedMessages.join(', ');
}

function translateErrorMessage(err: string): string {
  for (const { key, value } of messagesError) {
    const matches = err.match(key);
    if (matches) {
      return buildMessage(matches, value);
    }
  }

  return err;
}

function buildMessage(
  matches: RegExpMatchArray,
  value: string | ((matches: RegExpMatchArray) => string)
): string {
  if (typeof value === 'function') {
    return value(matches);
  }
  return value.replace(/\$(\d+)/g, (_, index) => matches[index]);
}
